import React from 'react';
import { cn } from '../../utils';

export type AnimatedNumberProps = {
  value: number;
  className?: string;
  springOptions?: Record<string, unknown>;
  as?: React.ElementType;
};

function AnimatedNumberComponent({
  value,
  className,
  as: Component = 'span',
}: AnimatedNumberProps) {
  return React.createElement(
    Component,
    { className: cn('tabular-nums', className) },
    value.toLocaleString()
  );
}

export const AnimatedNumber = React.memo(AnimatedNumberComponent);
